:host {
  display: block;
}

svg {
  max-width: 20vw;
  @include media-breakpoint-up(sm) {
    max-width: 100%;
  }
}

// .graphic-yellow {
//   .primary {
//     fill: var(--bs-blue-500, #1b526a);
//   }
//   .secondary {
//     fill: var(--bs-yellow-400, #ffb550);
//   }
//   .tertiary {
//     fill: var(--bs-yellow-100, #ffeace);
//   }
// }
// .graphic-blue {
//   .primary {
//     fill: var(--bs-blue-500, #1b526a);
//   }
//   .secondary {
//     fill: #5ba6bf;
//   }
//   .tertiary {
//     fill: var(--bs-blue-300, #d3e8f2);
//   }
// }
